// extracted by mini-css-extract-plugin
module.exports = {"error":"ZoomedImage_error__pTzEx","loading":"ZoomedImage_loading__Ovwx_","loaded":"ZoomedImage_loaded__VbjHq","imageLoad":"ZoomedImage_imageLoad__X3rGv"};